
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^webpack_container_remote_art_(liveconnect_(gateway|platform_settings|utils)|datalake_(gateway|platform_settings|utils)|a(gentlab_(agent_(gateway|utils)|PlaygroundRuntime|platform_settings)|ppstudio_app_studio_utils)|superadmin_super_admin_(gateway|utils))$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
